import amplitude, { AmplitudeClient } from "amplitude-js";

let client: AmplitudeClient | undefined;
const amplitudeKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
if (
  amplitudeKey &&
  amplitudeKey.length &&
  import.meta.env.VITE_ENVIRONMENT === "production"
) {
  client = amplitude.getInstance();
  client.init(amplitudeKey);
}

export default client;
